import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

import { Actions, State } from "../../types";
import { Login } from "./Login";

enum ActiveTab {
  login = "login",
}

type Props = Readonly<{
  actions: Actions;
  auth: State["auth"];
}>;

export const NotAuthenticated = ({ actions, auth }: Props) => {
  const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.login);
  return (
    <div className="p-3">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === ActiveTab.login ? "active" : ""}
            onClick={() => {
              setActiveTab(ActiveTab.login);
            }}
          >
            Login
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane className="pb-2 pt-2" tabId={ActiveTab.login}>
          <Login actions={actions} auth={auth} />
        </TabPane>
      </TabContent>
    </div>
  );
};
NotAuthenticated.displayName = "NotAuthenticated";
